import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { GlobalNotificationService } from '../services/global-notification.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const globalErrorHandler = inject(GlobalNotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Extract operation name from URL or request for better error messages
      const operation = extractOperationName(req.url, req.method);

      // Handle the error through global error handler
      globalErrorHandler.handleError(error, operation);

      // Re-throw the error so components can still handle it if needed
      return throwError(() => error);
    }),
  );
};

function extractOperationName(url: string, method: string): string {
  // Extract meaningful operation name from URL and HTTP method
  const path = url.split('?')[0]; // Remove query parameters
  const segments = path.split('/').filter((segment) => segment); // Split by '/' and remove empty segments

  if (segments.length === 0) {
    return method;
  }

  const lastSegment = segments[segments.length - 1];

  // Create readable operation name
  switch (method.toUpperCase()) {
    case 'GET':
      return `Loading ${lastSegment}`;
    case 'POST':
      return `Creating ${lastSegment}`;
    case 'PUT':
    case 'PATCH':
      return `Updating ${lastSegment}`;
    case 'DELETE':
      return `Deleting ${lastSegment}`;
    default:
      return `${method} ${lastSegment}`;
  }
}
